const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/1c644e56cddf516eacde8781ded33937/e9560f414d66cc985767c3e7d3e0dff0.jpeg"
                alt="Chevrokee Automotriz"
                className="h-10 w-10 rounded-full object-cover"
              />
              <span className="text-white font-bold text-base">
                Chevrokee <span className="text-[#2563eb]">Automotriz</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Especialistas en repuestos mecánicos para Chevrolet, Suzuki, Jeep, RAM, Dodge e Isuzu en Bogotá, Colombia.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-whatsapp-line', href: WHATSAPP_LINK },
                { icon: 'ri-facebook-circle-line', href: '#' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="w-9 h-9 flex items-center justify-center bg-gray-800 hover:bg-[#2563eb] text-gray-400 hover:text-white rounded-lg transition-all duration-200 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Marcas */}
          <div>
            <h4 className="text-[#2563eb] text-xs font-bold uppercase tracking-widest mb-4">Marcas</h4>
            <ul className="space-y-2">
              {['Chevrolet', 'Suzuki', 'Jeep', 'RAM', 'Dodge', 'Isuzu'].map((brand) => (
                <li key={brand}>
                  <a
                    href={`#${brand.toLowerCase()}`}
                    className="text-gray-500 hover:text-[#2563eb] text-sm transition-colors cursor-pointer"
                  >
                    {brand}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Productos */}
          <div>
            <h4 className="text-[#2563eb] text-xs font-bold uppercase tracking-widest mb-4">Productos</h4>
            <ul className="space-y-2">
              {['Motores y Culatas', 'Suspensión', 'Amortiguadores', 'Transmisión', 'Sistema de Frenos', 'Refrigeración'].map((p) => (
                <li key={p}>
                  <a
                    href="#productos"
                    className="text-gray-500 hover:text-[#2563eb] text-sm transition-colors cursor-pointer"
                  >
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-[#2563eb] text-xs font-bold uppercase tracking-widest mb-4">Contacto</h4>
            <ul className="space-y-3">
              {[
                { icon: 'ri-map-pin-line', text: 'Bogotá, Sector 7 de Agosto' },
                { icon: 'ri-whatsapp-line', text: '+57 305 709 6663' },
                { icon: 'ri-time-line', text: 'Lun – Sáb: 8AM – 6PM' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-2 text-gray-500 text-sm">
                  <i className={`${item.icon} text-[#2563eb] mt-0.5 flex-shrink-0`}></i>
                  {item.text}
                </li>
              ))}
            </ul>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer mt-4"
            >
              <i className="ri-whatsapp-line"></i>
              Cotizar
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800/60 py-5">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs text-center sm:text-left">
            © {currentYear} Chevrokee Automotriz. Todos los derechos reservados. Bogotá, Colombia.
          </p>
          <p className="text-gray-700 text-xs">
            Especialistas en repuestos mecánicos · No trabajamos latonería
          </p>
        </div>
      </div>
    </footer>
  );
}
